var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadSoftclipcurve = function SvgFadSoftclipcurve(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M233 64.5h-28.495c-18.104 0-32.517 4.04-49.695 18.089-15.765 12.892-30.941 31.655-39.559 46.948-12.478 22.144-33.858 39.953-43.54 43.463-9.68 3.51-23.202 3.5-30.711 3.5H25V192h23.5c9.747 0 26.265-.681 39.867-7.61 18.496-9.42 33.507-35.51 47.578-54.853 9.879-13.579 21.773-27.756 32.732-36.034C182.775 82.853 196.637 80 216.5 80H233V64.5z",
    fillRule: "evenodd"
  })));
};
export { SvgFadSoftclipcurve as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-softclipcurve.eedd70fa.svg";